import type { ConferenceEvent } from '@conference/shared';
import apiClient from './apiClient';
import type { EventOrganizerRole, WorkspaceMember } from './workspaceService';

export interface AdminEvent extends ConferenceEvent {
  workspace_id: string;
  effective_role: EventOrganizerRole;
  effective_content_ingestion_enabled: boolean;
}

export interface EventOrganizer {
  user_id: string;
  email: string;
  name: string;
  role: EventOrganizerRole;
}

export const adminEventService = {
  list: (workspaceId: string) => apiClient.get<AdminEvent[]>(`/admin/events?workspace_id=${encodeURIComponent(workspaceId)}`),
  get: (eventId: string) => apiClient.get<AdminEvent>(`/admin/events/${eventId}`),
  create: (workspaceId: string, input: Record<string, unknown>) => apiClient.post<AdminEvent>('/admin/events', { ...input, workspace_id: workspaceId }),
  update: (eventId: string, input: Record<string, unknown>) => apiClient.patch<AdminEvent>(`/admin/events/${eventId}`, input),
  remove: (eventId: string) => apiClient.delete<void>(`/admin/events/${eventId}`),
  listOrganizers: (eventId: string) => apiClient.get<EventOrganizer[]>(`/admin/events/${eventId}/organizers`),
  listEligibleOrganizers: (eventId: string) => apiClient.get<WorkspaceMember[]>(`/admin/events/${eventId}/eligible-organizers`),
  saveOrganizer: (eventId: string, userId: string, role: EventOrganizerRole) => apiClient.post<EventOrganizer>(`/admin/events/${eventId}/organizers`, { user_id: userId, role }),
  removeOrganizer: (eventId: string, userId: string) => apiClient.delete<void>(`/admin/events/${eventId}/organizers/${userId}`),
};

export default adminEventService;
